export default "__VITE_ASSET__3iTlxZU7__"